import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Fragment, useEffect, useRef, useState } from "react";
import PrivateRoute from "./PrivateRoute";
import loadable from "./utils/loadable";
import { dashboardSideBar, sideBarLinks } from "./utils/constants";
import DefaultDashboard from "./layout/DefaultDashboard";
import PublicRoutes from "./layout/PublicRoutes";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  // NotFound,
  Dashboard,
  Login,
  RegisterPage,
  ForgotPassword,
  Purchase,
  About,
  Privacy,
  Terms,
  Cancellation,
  Shipping,
  Contact,
  CoinEarn,
  FractionsEarn,
  OnlinePurchase,
  Delegates,
  Community,
  // TeamAndPartners,
  ProposalList,
  ProposalForm,
  ProposalDetail,
  DeligatesDetails,
  Maintenance,
  DaoHome,
  TwitterOauth,
  ScannerDetails,
  DraftList,
  ReportTwo,
  Report,
  ReportOne,
  Scanner,
  ClubReport,
  FlagCommunication,
  CouponLeaderboard,
} from "./pages/pageListAsync";
import ReactGA from "react-ga4";
import { onMessageListener } from "./firebaseInit";
import { Toaster } from "react-hot-toast";
import DaoPrivateRoue from "./DaoPrivateRoue";
// import MetaTags from "./pages/MetaTags";
import { HelmetProvider } from "react-helmet-async";
import "./i18n";

import {
  Landing,
  NotFound,
  ContactUs,
  Transparency,
  DynamicComp,
  Home,
  Blog,
  BlogDetails,
  NewDetails,
  // BuildWithMst,
  // Contacts,
  PrivacyPolicy,
  TermsAndConditions,
  KycPolicy,
  AmlPolicy,
  AboutW,
  BuildOnMST,
  MstResearchProgram,
  AboutNew,
  AboutUs,
  Teams,
  ValidatorPage,
} from "./containers/pageListAsync";
import {
  Ambassdor,
  DynamicTitle,
  LinkedinTracker,
  NotificationComponent,
  Notifications,
  PartnersPage,
  // PerspectiveGrid,
  TrackPageView,
  ScrollToTop,
  UserProfile,
  YouTubeLinkModal,
} from "./components";
import { setNotificationUpdate } from "./redux/Slice/notificationSlice";
import GlobalInternetHandler from "./components/GlobalInternetHandler";
import BridgeKeyNoticeModal from "./components/modals/BridgeKeyNoticeModal";
const BlockValidationPage = loadable(
  () => import("./components/Learn/Block-validation/page"),
);
const DaoPage = loadable(() => import("./components/Learn/dao/page"));
const FractinalValidatorPage = loadable(
  () => import("./components/Learn/fractional-validator/page"),
);
const Grant = loadable(() => import("./components/Learn/grant/page"));
const TransparencyPage = loadable(
  () => import("./components/Learn/transperancy/page"),
);
const SolidityPage = loadable(() => import("./components/Learn/solidity/page"));
const OnchainCertificate = loadable(
  () => import("./components/UsecasePage/On-Chain-Certificate/page"),
);
const SupplyChainTransparency = loadable(
  () => import("./components/UsecasePage/Supply-Chain-Transparency/page"),
);
const TokenizedRealState = loadable(
  () => import("./components/UsecasePage/Tokenized-Real-Estate/page"),
);
const NftTicketing = loadable(
  () => import("./components/UsecasePage/NFT-Ticketing/page"),
);
const InsuranceAutomation = loadable(
  () => import("./components/UsecasePage/Insurance-Automation/page"),
);
const ContactsUs = loadable(() => import("./components/contact/page"));
const CareersPage = loadable(() => import("./pages/Career/page"));
const ProtocolPage = loadable(() => import("./components/Protocol/page"));
const UpcomingEventsPage = loadable(
  () => import("./components/upcoming-events/page"),
);
const PastEvents = loadable(() => import("./components/past-event/page"));
const CorporateEventsPage = loadable(
  () => import("./components/corporate-events/page"),
);
const CollegeEventsPage = loadable(
  () => import("./components/college-events/page"),
);
const CorporateEventDetails = loadable(
  () => import("./components/corporate-events/details"),
);
const CollegeEventDetails = loadable(
  () => import("./components/college-events/details"),
);
const CarbonCreditTracking = loadable(
  () => import("./components/UsecasePage/Carbon-Credit-Tracking/page"),
);
const CharityDonation = loadable(
  () => import("./components/UsecasePage/Charity-Donations/page"),
);
const DecentralizedPlateform = loadable(
  () => import("./components/UsecasePage/Decentralized-Social-Platforms/page"),
);
const DecentralizedVoting = loadable(
  () => import("./components/UsecasePage/Decentralized-Voting/page"),
);
const CertificateMinting = loadable(() => import("./pages/CertificateMinting"));
const CertificateVerify = loadable(
  () => import("./pages/CertificateMinting/Verify"),
);
const DigitalAssetExcange = loadable(
  () => import("./components/UsecasePage/Digital-Asset-Exchange/page"),
);
const DigitalIdentityKyc = loadable(
  () => import("./components/UsecasePage/Digital-Identity-KYC/page"),
);
const EducationCredentials = loadable(
  () => import("./components/UsecasePage/Education-Credentials/page"),
);
const EnterpriseWorkFlow = loadable(
  () => import("./components/UsecasePage/Enterprise-Workflow-Automation/page"),
);
const FreelanceMarketplace = loadable(
  () => import("./components/UsecasePage/Freelance-Marketplace/page"),
);
const GamingAssetOwnership = loadable(
  () => import("./components/UsecasePage/Gaming-Asset-Ownership/page"),
);
const GoldCommunityTokenization = loadable(
  () => import("./components/UsecasePage/Gold-Commodity-Tokenization/page"),
);
const HealthcarePage = loadable(
  () => import("./components/UsecasePage/Healthcare-Records/page"),
);
const LandRecords = loadable(
  () => import("./components/UsecasePage/Land-Records/page"),
);
const LoyaltyRewards = loadable(
  () => import("./components/UsecasePage/Loyalty-Rewards/page"),
);
const MstAcademy = loadable(() => import("./pages/Mst-Academy/Mst-Academy"));
const Roadmap = loadable(() => import("./components/roadmap/page"));
const ProposalRedirect = loadable(() => import("./pages/Proposal/Proposal"));
const GamesPage = loadable(() => import("./components/Games/page"));
const Ambassador = loadable(() => import("./components/ambassador2/page"));
const BuildOnMSTForm = loadable(() => import("./components/buildonmst1/page"));
const BrandingPage = loadable(() => import("./components/Branding/page"));

const TrackingId = process.env.REACT_APP_TRACKING_ID;
const logClientId = () => {
  ReactGA.gtag("get", TrackingId, "client_id", () => {});
};
function App() {
  useEffect(() => {
    if (process.env.REACT_APP_ENVIRONMENT != "development" && TrackingId) {
      ReactGA.send({
        hitType: "pageview",
        page: window?.location.pathname + window?.location.search,
      });
    }
  }, []);

  useEffect(() => {
    if (process.env.REACT_APP_ENVIRONMENT != "development" && TrackingId) {
      logClientId();
    }
  }, []);

  const location = useLocation();
  const { pathname, hash } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [notification, setNotification] = useState(null);
  const lastMessageIdRef = useRef(null);
  const { userData } = useSelector((state) => state?.user || {});
  const hasRedirected = useRef(false);
  const websiteDisable = false;
  useEffect(() => {
    if (hash) {
      let attempts = 0;
      const targetId = hash.replace("#", "");

      const tryScroll = () => {
        const element = document.getElementById(targetId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
        attempts++;
        if (attempts < 5) {
          setTimeout(tryScroll, 300);
        }
      };

      setTimeout(tryScroll, 100);
    } else {
      window?.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  const getAccessToken = () => {
    const params = new URLSearchParams(location.search);
    const data = params.get("accessToken");
    if (data) {
      Cookies.set("accessToken", data);
      sessionStorage.setItem("referredAs", "User");
    }
  };
  useEffect(() => {
    getAccessToken();
    import("react-toastify/dist/ReactToastify.css");
  }, []);

  // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const CookiesData =
      sessionStorage.getItem("referredAs") == "User"
        ? Cookies.get("accessToken")
        : Cookies.get("pfaccessToken");
    const network = process.env.REACT_APP_NETWORK === "mainnet";
    if (
      userData &&
      network &&
      Object.keys(userData).length > 0 &&
      !userData?.isVerified &&
      CookiesData
    ) {
      navigate("/portal/kyc");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData, userData?.isVerified]);

  useEffect(() => {
    const unsubscribe = onMessageListener((payload) => {
      if (
        payload?.messageId &&
        payload.messageId === lastMessageIdRef.current
      ) {
        return;
      }
      setNotification(payload);
      dispatch(setNotificationUpdate(true));
      setShow(true);
    });
    return () => {
      if (typeof unsubscribe === "function") unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (userData?.email) {
      return;
    }
    const CookiesData =
      sessionStorage.getItem("referredAs") === "User"
        ? Cookies.get("accessToken")
        : Cookies.get("pfaccessToken");
    const isUserDataEmpty = Object.keys(userData).length !== 0;

    if (
      !hasRedirected.current &&
      isUserDataEmpty &&
      !userData?.email &&
      CookiesData
    ) {
      hasRedirected.current = false;
      navigate("/portal/profile", { replace: true });
    }
  }, [userData, userData?.email, location.pathname]);

  if (websiteDisable && pathname.startsWith("/portal")) {
    return (
      <HelmetProvider>
        <Maintenance />
      </HelmetProvider>
    );
  }

  return (
    <>
      <HelmetProvider>
        {pathname.startsWith("/portal") ? (
          <ToastContainer
            toastStyle={{ zIndex: 9999 }}
            className="portal-toast"
            pauseOnFocusLoss={false}
          />
        ) : (
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss={false}
            draggable
            pauseOnHover={false}
            theme="colored"
          />
        )}
        <TrackPageView />
        <Notifications />
        <DynamicTitle />
        {/* {!pathname.startsWith("/portal") && <VideoPlay />} */}
        {!pathname.startsWith("/portal") && <LinkedinTracker />}
        {(pathname.startsWith("/portal") ||
          pathname.startsWith("/portal/")) && <YouTubeLinkModal />}
        {pathname.startsWith("/portal") &&
          (sessionStorage.getItem("referredAs") == "User"
            ? Cookies.get("accessToken")
            : Cookies.get("pfaccessToken")) && <BridgeKeyNoticeModal />}
        {(pathname.startsWith("/portal") ||
          pathname.startsWith("/portal/")) && (
          <NotificationComponent
            notification={notification}
            show={show}
            setShow={setShow}
            setNotification={setNotification}
            lastMessageIdRef={lastMessageIdRef}
          />
        )}
        <Toaster
          reverseOrder={false}
          toastOptions={
            pathname.startsWith("/portal")
              ? {
                  className: "portal-hot-toast",
                  success: { className: "portal-hot-toast is-success" },
                  error: { className: "portal-hot-toast is-error" },
                }
              : undefined
          }
        />
        {/* <MetaTags /> */}
        <GlobalInternetHandler />
        {!pathname.startsWith("/portal") && <ScrollToTop />}
        <Routes>
          <Route
            // index
            path="portal/register/:referralCode?"
            element={
              <PublicRoutes>
                {" "}
                <RegisterPage />
              </PublicRoutes>
            }
          ></Route>
          <Route
            path="portal/login"
            element={
              <PublicRoutes>
                {" "}
                <Login />
              </PublicRoutes>
            }
          ></Route>
          <Route
            path="portal/forgot-password"
            element={
              <PublicRoutes>
                {" "}
                <ForgotPassword />
              </PublicRoutes>
            }
          ></Route>

          <Route
            path="/portal"
            element={
              <PublicRoutes>
                <DefaultDashboard />
              </PublicRoutes>
            }
          >
            {sideBarLinks.map((item, index) => (
              <Route
                key={index}
                path={item.path}
                element={<Fragment>{item.component}</Fragment>}
              ></Route>
            ))}
            <Route path="about" element={<About />} />
            <Route path="privacy" element={<Privacy />} />
            <Route path="terms" element={<Terms />} />
            <Route path="cancellation" element={<Cancellation />} />
            <Route path="shipping" element={<Shipping />} />
            <Route path="contact" element={<Contact />} />
            <Route path="tokens-scan" element={<Scanner />} />
            <Route path="token/:address" element={<ScannerDetails />} />
          </Route>
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          >
            <Route index path="portal/dashboard" element={<Report />} />
            <Route path="portal/coin-earn" element={<CoinEarn />} />
            <Route path="portal/club-report" element={<ClubReport />} />
            <Route
              path="portal/coupon-leaderboard"
              element={<CouponLeaderboard />}
            />
            <Route
              path="portal/flag-communication/:flagId"
              element={<FlagCommunication />}
            />
            <Route
              path="portal/fraction-earn/:date/:nodeId"
              element={<FractionsEarn />}
            ></Route>
            <Route
              index
              path="portal/purchase-receipt/:numberFraction"
              element={<Purchase />}
            />
            <Route
              index
              path="portal/dao/proposal-list"
              element={
                <DaoPrivateRoue>
                  <ProposalList />
                </DaoPrivateRoue>
              }
            />
            <Route
              index
              path="portal/dao/proposal-draft-list"
              element={
                <DaoPrivateRoue>
                  <DraftList />
                </DaoPrivateRoue>
              }
            />
            <Route
              path="portal/dao/proposal-form/:draftID?"
              element={
                <DaoPrivateRoue>
                  <ProposalForm />
                </DaoPrivateRoue>
              }
            />
            <Route
              index
              path="portal/dao/proposal-detail/:id/:proposalId"
              element={
                <DaoPrivateRoue>
                  <ProposalDetail />
                </DaoPrivateRoue>
              }
            />
            <Route
              index
              path="portal/dao/delegates"
              element={
                <DaoPrivateRoue>
                  <Delegates />
                </DaoPrivateRoue>
              }
            />
            <Route
              index
              path="portal/dao/delegate-detail/:id"
              element={
                <DaoPrivateRoue>
                  <DeligatesDetails />
                </DaoPrivateRoue>
              }
            />
            <Route
              index
              path="portal/dao"
              element={
                <DaoPrivateRoue>
                  <DaoHome />
                </DaoPrivateRoue>
              }
            />
            <Route
              index
              path="portal/online-purchase"
              element={<OnlinePurchase />}
            />
            <Route index path="portal/profile" element={<UserProfile />} />
            {/* <Route index path="dashboard" element={<DashboardLanding />}></Route> */}
            {/* <Route path="/report/:id?" element={<Report />}></Route> */}
            <Route path="portal/report/:id" element={<ReportOne />} />
            <Route path="portal/report/:id/:1231" element={<ReportTwo />} />
            <Route
              path="portal/twitter-oauth/code"
              element={<TwitterOauth />}
            />
            {dashboardSideBar.map(
              (item, index) =>
                item.title !== "Dashboard" && (
                  <Route
                    key={index}
                    path={item.path}
                    element={<Fragment>{item.component}</Fragment>}
                  />
                ),
            )}
          </Route>

          <Route path="/proposal" element={<ProposalRedirect />} />

          {/* <Route path="/grid" element={<PerspectiveGrid />} /> */}
          <Route path="/" element={<Landing />}>
            <Route index element={<Home />} />
            <Route path="/*" element={<NotFound />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/partnerships" element={<PartnersPage />} />
            {/* <Route path="/contact" element={<ContactUs />} /> */}
            {/* <Route path="/about-mst" element={<AboutNew />} /> */}
            <Route
              path="/block-validation-process"
              element={<BlockValidationPage />}
            />
            <Route path="/dao-and-mst-chain" element={<DaoPage />} />
            <Route
              path="/fractional-node"
              element={<FractinalValidatorPage />}
            />
            {/* <Route path="/build-on-mst" element={<BuildOnMST />} /> */}
            <Route path="/buildonmst" element={<BuildOnMSTForm />} />
            <Route path="/build-on-mst" element={<BuildOnMSTForm />} />
            <Route path="/evm-blockchain" element={<SolidityPage />} />
            {/* <Route path="/Ambassador" element={<Ambassdor />} /> */}
            <Route path="/ambassador" element={<Ambassador />} />
            <Route path="/transperancy" element={<TransparencyPage />} />
            <Route
              path="/solutions/retail-commerce-and-supply-chain"
              element={<Navigate to="/Supply-Chain-Transparency" replace />}
            />
            <Route
              path="/solutions/nfts-art-and-culture"
              element={<Navigate to="/nft-event-ticketing-blockchain" replace />}
            />
            <Route
              path="/solutions/enterprise-consumer-apps"
              element={
                <Navigate to="/Enterprise-Workflow-Automation" replace />
              }
            />
            <Route
              path="/solutions/decentralized-finance"
              element={<Navigate to="/" replace />}
            />
            <Route
              path="/solutions/institution-and-capital-markets"
              element={<Navigate to="/" replace />}
            />
            <Route path="/solutions/:slug" element={<DynamicComp />} />
            {/* <Route path="/block-validation" element={<BlockValidationPage />} /> */}
            {/* <Route path="/dao" element={<DaoPage />} /> */}
            {/* <Route
              path="fractional-validator"
              element={<FractinalValidatorPage />}
            /> */}
            <Route path="/grant" element={<Grant />} />
            {/* <Route path="/solidity" element={<SolidityPage />} /> */}
            <Route
              path="/Supply-Chain-Transparency"
              element={<SupplyChainTransparency />}
            />
            <Route
              path="/on-chain-certificate"
              element={<OnchainCertificate />}
            />
            <Route
              path="/tokenized-real-estate"
              element={<Navigate to="/real-estate-tokenization" replace />}
            />
            <Route
              path="/real-estate-tokenization"
              element={<TokenizedRealState />}
            />
            <Route
              path="/NFT-Ticketing"
              element={<Navigate to="/nft-event-ticketing-blockchain" replace />}
            />
            <Route
              path="/nft-event-ticketing-blockchain"
              element={<NftTicketing />}
            />
            <Route
              path="/insurance-automation"
              element={<InsuranceAutomation />}
            />
            <Route
              path="/Insurance-Automation"
              element={<InsuranceAutomation />}
            />
            <Route
              path="/Carbon-Credit-Tracking"
              element={<Navigate to="/carbon-credit-management" replace />}
            />
            <Route
              path="/carbon-credit-tracking"
              element={<Navigate to="/carbon-credit-management" replace />}
            />
            <Route
              path="/carbon-credit-management"
              element={<CarbonCreditTracking />}
            />
            <Route
              path="/Charity-Donations"
              element={<Navigate to="/blockchain-charity-donations" replace />}
            />
            <Route
              path="/charity-donations"
              element={<Navigate to="/blockchain-charity-donations" replace />}
            />
            <Route
              path="/blockchain-charity-donations"
              element={<CharityDonation />}
            />
            <Route
              path="/decentralized-social-platforms"
              element={<DecentralizedPlateform />}
            />
            <Route
              path="/Decentralized-Social-Platforms"
              element={<DecentralizedPlateform />}
            />
            <Route
              path="/Decentralized-Voting"
              element={<DecentralizedVoting />}
            />
            <Route path="/nft-minting" element={<CertificateMinting />} />
            <Route
              path="/nft-minting/verify/:certificateId"
              element={<CertificateVerify />}
            />
            <Route
              path="/Digital-Asset-Exchange"
              element={<DigitalAssetExcange />}
            />
            <Route
              path="/Digital-Identity-KYC"
              element={<DigitalIdentityKyc />}
            />
            <Route
              path="/Education-Credentials"
              element={<EducationCredentials />}
            />
            <Route
              path="/Enterprise-Workflow-Automation"
              element={<EnterpriseWorkFlow />}
            />
            <Route
              path="/Freelance-Marketplace"
              element={<FreelanceMarketplace />}
            />
            <Route
              path="/Gaming-Asset-Ownership"
              element={<GamingAssetOwnership />}
            />
            <Route
              path="/Gold-Commodity-Tokenization"
              element={<GoldCommunityTokenization />}
            />
            <Route path="/Healthcare-Records" element={<HealthcarePage />} />
            <Route path="/Land-Records" element={<LandRecords />} />
            <Route path="/Loyalty-Rewards" element={<LoyaltyRewards />} />

            <Route path="/contact" element={<ContactsUs />} />
            <Route path="/Career" element={<CareersPage />} />
            <Route path="/Protocol" element={<ProtocolPage />} />
            <Route path="/upcoming-events" element={<UpcomingEventsPage />} />
            <Route path="/past-event" element={<PastEvents />} />
            <Route path="/corporate-events" element={<CorporateEventsPage />} />
            <Route path="/corporate-events/:slug" element={<CorporateEventDetails />} />
            <Route path="/college-events" element={<CollegeEventsPage />} />
            <Route path="/college-events/:slug" element={<CollegeEventDetails />} />
            <Route path="/validator" element={<ValidatorPage />} />
            <Route path="/fractional-validator" element={<ValidatorPage />} />
            <Route path="/teams" element={<Teams />} />
            <Route path="/blogs" element={<Blog />} />
            <Route path="/blog-details/:slug" element={<BlogDetails />} />

            <Route path="/news-details/:slug" element={<NewDetails />} />
            <Route path="/build-with-mst" element={<Grant />} />
            {/* <Route path="/contact" element={<Contacts />} /> */}
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsAndConditions />} />
            {/* <Route path="/cancellation" element={<CancellationW />} /> */}
            <Route path="/kyc-policies" element={<KycPolicy />} />
            <Route path="/aml-policies" element={<AmlPolicy />} />
            <Route
              path="/community"
              element={<Navigate to="/portal" replace />}
            />
            <Route
              path="/community/*"
              element={<Navigate to="/portal" replace />}
            />
            <Route
              path="/mst-research-program"
              element={<Navigate to="/grant" replace />}
            />
            <Route path="/Mst-Academy" element={<MstAcademy />} />
            <Route path="/roadmap" element={<Roadmap />} />
            <Route path="/games" element={<GamesPage />} />
            <Route path="/branding" element={<BrandingPage />} />
          </Route>

          {/* <Route path="/" element={<Landing />}> */}
          {/* <Route index element={<Home />} /> */}
          {/* <Route path="/*" element={<NotFounds />} /> */}

          {/* <Route path="/about-us" element={<AboutW />} /> */}
          {/* <Route path="/transparency" element={<Transparency />} /> */}

          {/* <Route path="/privacy" element={<Privacyy />} /> */}
          {/* <Route path="/terms" element={<TermsC />} /> */}

          {/* <Route path="/cancellation" element={<CancellationW />} /> */}
          {/* <Route path="/shipping" element={<Shippings />} /> */}
          {/* <Route path="/validator-benefits" element={<Validator />} /> */}
          {/* <Route path="/fortunx" element={<FortunX />} />/ */}
          {/* <Route path="/gaming" element={<Gaming />} /> */}
          {/* <Route path="/sattvashuffle" element={<Sattvashuffle />} /> */}
          {/* <Route path="/klethesia" element={<Klethesia />} /> */}
          {/* </Route> */}
        </Routes>
      </HelmetProvider>
    </>
  );
}

export default App;
